import { getEnvironment, REACT_APP_ONBOARDING_JOURNEY_URL } from "./environment";
import { SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY } from "../Constants/constant";

export const toSentenceCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const redirectToPaymentPage = () => {
  const { PAYMENT_URL } = getEnvironment();
  if(window.parent){
    window.parent.location.href = PAYMENT_URL;
  }else{
    window.location.href = PAYMENT_URL;
  }
}

export const redirectToOnboardingJourney = (token) => {
  const redirectURL = `${REACT_APP_ONBOARDING_JOURNEY_URL}auto-login?token=${token}`;
  if(window.parent){
    return window.parent.location.href = redirectURL;
  }
  window.location.href = redirectURL;
}

export const strEncryptionSHA256 = async (str) => {
  if (!str) {
    return 'NA';
  }

  const data = new TextEncoder().encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

export const getSelectedProductType = () => {
  const productId = Number(localStorage.getItem(SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY));
  const productMap = {
    1: "emi",
    2: "payday",
  };
  return productMap[productId] || "na";
}


export const getGeolocation = () => {
  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.log("Geolocation error:", error);
          resolve({ latitude: null, longitude: null });
        }
      );
    } else {
      console.log("Geolocation not supported");
      resolve({ latitude: null, longitude: null });
    }
  });
};